import { urlApiTegra, post, get } from "../../../service/api";

export const postJobSetting = ({ body, token }: { body: { idNotify: number; notificade: "approve" | "missing" | "excess" }; token: string }) => {
  return post(`${urlApiTegra}/job-settings`, body, token);
};

export const getJobSetting = ({ token }: { token: string }) => {
  return get(`${urlApiTegra}/job-settings`, token);
};
